import {defineStore} from "pinia";
import {ref} from "vue";
import {loadPaymentMethods} from "@/dataLayer/service/api";

export const usePaymentStore = defineStore('payment', () => {
  const paymentMethods = ref([]);
  const loading = ref(false);
  const error = ref(null);

  async function fetchPaymentMethods() {
    loading.value = true;
    error.value = null;
    try {
      paymentMethods.value = await loadPaymentMethods();
    } catch (e) {
      console.error("Failed to load payment methods:", e);
      error.value = e.message || "Failed to load payment methods";
    } finally {
      loading.value = false;
    }
  }

  // Load payment methods when the store is initialized
  fetchPaymentMethods();

  return {
    paymentMethods,
    loading,
    error,
    fetchPaymentMethods
  };
});
